import * as React from 'react';
import { useState, useEffect } from 'react';
import config from '../../config';
import StandardLogin from './standardLogin';

const {
    loginUrl,
    forgotUrl
} = config;

function Login() {
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [formAction, setFormAction] = useState('');
    const [passwordRequired, setPasswordRequired] = useState(true);

    useEffect(() => {
        const searchParams = new URL(window.location as any)?.searchParams;
        const err = searchParams.get('error') as string;
        setError(err);
        const msg = searchParams.get('message') as string;
        setMessage(msg);
    }, []);

    const onLogin = () => {
        setPasswordRequired(true);
        const searchParams = new URL(window.location as any)?.searchParams;
        const returnPath = (searchParams.get('returnPath') as string) || '';
        const host = window.location.origin;
        const returnUrl = `${host}${returnPath}`;
        const returnUrlError = `${host}/login`;
        const baseUrl = loginUrl;
        const action = `${baseUrl}${returnUrl}&return_url_error=${returnUrlError}`;

        setFormAction(action);
    };

    const onForgot = () => {
        setPasswordRequired(false);
        const host = window.location.origin;
        const resetUrl = `${host}/reset`;
        const originUrl = `${host}/login`;

        const action = `${forgotUrl}&reset_url=${resetUrl}&origin_url=${originUrl}`;
        setFormAction(action);
    };

    return (
        <StandardLogin
            formAction={formAction}
            error={error}
            message={message}
            passwordRequired={passwordRequired}
            onLogin={onLogin}
            onForgot={onForgot}
        />
    );
}

export default Login;
